import * as React from "react";

const Devices = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer15"
      fill="none"
      fillOpacity="1"
      stroke="#000"
      strokeDasharray="none"
      strokeDashoffset="22.224"
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeOpacity="1"
      strokeWidth="0.4"
    >
      <circle id="path71" cx="3.175" cy="3.175" r="0.598" opacity="1"></circle>
      <path
        id="path72"
        d="M4.368 1.982a1.687 1.687 0 0 1 0 2.386M1.982 1.982a1.687 1.687 0 0 0 0 2.386"
        opacity="1"
      ></path>
      <path
        id="path73"
        d="M5.046 1.304a2.646 2.646 0 0 1 0 3.742M1.304 1.304a2.646 2.646 0 0 0 0 3.742"
        opacity="1"
      ></path>
    </g>
  </svg>
);

export default Devices;
